// extracted by mini-css-extract-plugin
module.exports = {"text_wrapper":"InfoMenuButton_text_wrapper__Xrl7G"};